<template>
  <div class="c_table_wrap">
    <table>
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">
          제목
        </td>
        <td>
          <div>
            <el-input v-model="title" maxlength="40" @input="parentChange('title', title)"></el-input>
            <div class="input_error">{{ validation.firstError('title') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">
          이미지
        </td>
        <td>
          <div class="img_update">
            <div class="icon_upload">
              <div class="board_upload" @click="changeType('files')">
                <el-upload
                    class="avatar-uploader"
                    :auto-upload="false"
                    action=""
                    :show-file-list="false"
                    list-type="picture"
                    :file-list="files"
                    :on-change="onlyOnePhotoChange"
                >
                  <img v-if="hasFile('files')" :src="files[0].org_url" class="avatar icon_img">
                  <i v-else class="el-icon-plus avatar-uploader-icon "></i>
                </el-upload>
                <div class="input_error pt0 pb0">Pc에서 노출되는 이미지입니다. <br>크기 23 x 23 에 최적화 되어있습니다.</div>
                <div class="input_error">{{ validation.firstError('files') }}</div>
              </div>
            </div>
          </div>
          <div class="img_update_mobile ml20">
            <div class="icon_upload">
              <div class="board_upload" @click="changeType('filesM')">
                <el-upload
                    class="avatar-uploader"
                    :auto-upload="false"
                    action=""
                    :show-file-list="false"
                    list-type="picture"
                    :file-list="filesM"
                    :on-change="onlyOnePhotoChange"
                >
                  <img v-if="hasFile('filesM')" :src="filesM[0].org_url" class="avatar icon_img_mobile">
                  <i v-else class="el-icon-plus avatar-uploader-icon icon_mobile"></i>
                </el-upload>
                <div class="input_error pt0 pb0">Mobile에서 노출되는 이미지입니다. <br>크기 54 x 54 에 최적화 되어있습니다.</div>
                <div class="input_error">{{ validation.firstError('filesM') }}</div>
              </div>
            </div>
          </div>
        </td>

      </tr>
      <tr>
        <td class="c_t_title">
          웹링크
        </td>
        <td>
          <div>
            <el-input v-model="url" maxlength="100" @input="parentChange('url', url)"></el-input>
            <div class="input_error">{{ validation.firstError('url') }}</div>
          </div>
        </td>
      </tr>

    </table>


  </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import iconValidator from "@/mixins/validators/iconValidator";
import elFileMixins from "@/mixins/elFileMixins";
import imageOption from "@/mixins/imageOption";

export default {
  name: "IconWriteDefaultLayout",
  mixins: [alertMixins, iconValidator, elFileMixins, imageOption],
  components: {},
  inject: ['iconWriteSetData'],

  provide() {
    return {}
  },
  props: {
    iconData: {
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
    if (this.hasIconData()) {
      this.initSetData();
    }
    EventBus.$on('IconWriteDefaultLayoutValidator', this.checkValidator);
  },
  beforeDestroy() {
    EventBus.$off('IconWriteDefaultLayoutValidator')

  },
  destroyed() {
  },
  computed: {},
  methods: {
    initSetData() {
      this.title = this.iconData.i_subject;
      this.parentChange('title', this.title);
      this.url = this.iconData.i_url;
      this.parentChange('url', this.url);

      if (!util.isEmpty(this.iconData.Files)) {
        this.iconData.Files[0].url = this.iconData.Files[0].org_url;
        this.files = this.iconData.Files
        this.parentChange('files', this.files);
      }

      if (!util.isEmpty(this.iconData.MobileFiles)) {
        this.iconData.MobileFiles[0].url = this.iconData.MobileFiles[0].org_url;
        this.filesM = this.iconData.MobileFiles
        this.parentChange('filesM', this.filesM);
      }

    },

    hasIconData() {
      return !util.isEmpty(this.iconData) && !util.isEmpty(this.iconData.i_idx);
    },
    hasFile(typeName) {
      if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName]) && this[typeName][0].hasOwnProperty('org_url')) {
        return true;
      }
      return false;
    },
    checkValidator(dataArr) {
      this.$validate(dataArr)
    },
    parentChange(key, value) {
      this.iconWriteSetData(key, value)

    },
  },
  watch: {},
}
</script>

<style scoped>

</style>